import { createAction } from 'redux-act';

import * as messageLogs from '../../core/messageLogs';

export const fetchMessageLogs = createAction(
  'get all messageLogs',
);
export const fetchMessageLogsSuccess = createAction(
  'get all messageLogs success',
);
export const fetchMessageLogsFail = createAction(
  'get all messageLogs fail',
  (error) => error
);




export const openEditMessageLog = createAction(
  'open edit messageLog modal'
);
export const closeEditMessageLog = createAction(
  'close edit messageLog modal'
);

export const reducer = {
  [fetchMessageLogs]: (state, payload) =>
    messageLogs.fetchMessageLogs(state, payload),
  [fetchMessageLogsSuccess]: (state, payload) =>
    messageLogs.fetchMessageLogsSuccess(state, payload),




  [openEditMessageLog]: (state, payload) =>
    messageLogs.openEditMessageLog(state, payload),
  [closeEditMessageLog]: (state, payload) =>
    messageLogs.closeEditMessageLog(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/messageLogs.module.js
 **/